import React from 'react';
import company from "assets/images/icon/company.png";
import companystatus from "assets/images/icon/company-status.png";
import onboard from "assets/images/icon/onboard.png";
import implementation from "assets/images/icon/implementation.png";
import Card from '../../components/Card';
import { Card as Bcard, Row, Col } from "react-bootstrap";
import edit from 'assets/images/icon/edit-orange.png'
import Table from '../../components/Table';

const headers = [
    { headerName: "Code", key: "code" },
    { headerName: "Name", key: "name" },
    { headerName: "Email", key: "email" },
    { headerName: "Residence", key: "residence" },
    { headerName: "Active Status", key: "active_status" },

];

const data = [
    {
        code: "#231",
        name: "Demo Smith",
        email: "Demo@epaylync.com",
        residence: "32 StreetUS",
        active_status: "Active",
    },
    {
        code: "#231",
        name: "Demo Smith",
        email: "Demo@epaylync.com",
        residence: "32 StreetUS",
        active_status: "Active",
    }, 
    {
        code: "#231",
        name: "Demo Smith",
        email: "Demo@epaylync.com",
        residence: "32 StreetUS",
        active_status: "Active",
    },
]

const userDetail = [
    { title: 'Gross Pay', count: 3, icon: company },
    { title: 'Reimbursements', count: 0, icon: companystatus },
    { title: 'Company Benefits', count: 1, icon: onboard },
    { title: 'Company Taxes', count: 0, icon: implementation },
]

function ViewContractor() {
    return (
        <div className='content' style={{ padding: "16px 24px 16px 16px" }}>
            <div className="start-new-payroll-section">
                <div>
                    <div className="row mt-2">
                        {userDetail?.map((item) => {
                            return <Card title={item?.title} count={item?.count} icon={item?.icon} />
                        })}

                    </div>
                </div>
                <div className='d-flex flex-row gap-4 mt-3'>
                    <Bcard className="employee-card p-4 " style={{ width: '100%' }}>
                        {/* Employee ID and Edit Button */}
                        <Row className="align-items-center">
                            <Col>
                                <small className="text-muted badge-title">Contractor Id</small>
                                <div className="fw-bold">b6c439ef-bb34-ef11-86c3-6045bdc7c4f5</div>
                            </Col>
                            <Col xs="auto">
                                <img src={edit} />
                            </Col>
                        </Row>

                        {/* Status Badges */}
                        <Row className="mt-4">
                            <Col className='d-flex flex-column col-lg-3'>
                                <span className='badge-title' >Onboard Status</span>
                                <span className="badge status-completed">Completed</span>
                            </Col>
                            <Col className='d-flex flex-column col-lg-3'>
                                <span className='badge-title' >Active Status</span>
                                <span className="badge status-active">Active</span>
                            </Col>
                            <Col className='d-flex flex-column col-lg-3 '>
                                <span className='badge-title'>Payment Portal</span>
                                <span className="badge status-no-user">No User</span>
                            </Col>
                        </Row>

                        {/* General Information */}
                        <hr />
                        <h6 className="fw-bold">General Information</h6>
                        <Row>
                            <Col className='col-lg-3'><small className="text-muted badge-title">Full Name</small><br /><span className='badge-value badge-title'>Demo Smith</span></Col>
                            <Col className='col-lg-3'><small className="text-muted badge-title">Payment Method</small><br /><span className='badge-value badge-title'>Paper Check</span></Col>
                            <Col className='col-lg-3'><small className="text-muted badge-title">SSN</small><br /><span className='badge-value badge-title'>****** 4742</span></Col>
                            <Col className='col-lg-3'><small className="text-muted badge-title">Date of Birth</small><br /><span className='badge-value badge-title'>Nov 07, 1985</span></Col>
                        </Row>
                        <Row className="mt-3">
                            <Col className='col-lg-3'><small className="text-muted badge-title">Start Date</small><br /><span className='badge-value badge-title'>Nov 07, 2019</span></Col>
                            <Col className='col-lg-3'><small className="text-muted badge-title">Termination Date</small><br /><span className='badge-value badge-title'>-</span></Col>
                        </Row>

                        {/* Contact Information */}
                        <hr />
                        <h6 className="fw-bold">Contact Information</h6>
                        <Row>
                            <Col><small className="text-muted badge-title">Primary Workplace</small><br /><span className='badge-value badge-title'>725 S 6th St, Las Vegas, NV, 89101, US</span></Col>
                            <Col><small className="text-muted badge-title">Department</small><br /><span className='badge-value badge-title'>No Department Assigned</span></Col>
                        </Row>
                    </Bcard>
                    <Bcard className="employee-card p-3 " style={{ width: '80%' }}>
                        <ui class="d-flex justify-content-between tab">
                            <li class="nav-link active " aria-current="page" href="#">Paystubs</li>
                            <li class="nav-link" href="#">Documents</li>
                            <li class="nav-link" href="#">Workplaces</li>
                            <li class="nav-link " href="#" tabindex="-1" aria-disabled="true">Benefits  </li>
                            <li class="nav-link" href="#" tabindex="-1" aria-disabled="true">Misc DED  </li>
                        </ui>
                        <Table headers={headers} data={data} />

                    </Bcard>
                </div>
            </div>
        </div>
    );
}


export default ViewContractor;
